/* unplugin-vue-components disabled */import { ElInput as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElIcon as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_1 from '~icons/ep/delete-filled';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "setting"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, "域名", -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "marginT10"
}, "asdasdadasdasdasdasdasdasdasdasdas", -1);
const _hoisted_4 = {
  class: "marginT10 flex cp",
  style: {
    "align-items": "center"
  }
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "marginR10"
}, "爱搭搭所大所大所大所多", -1);
const _hoisted_6 = {
  style: {
    "display": "flex",
    "justify-content": "flex-end"
  }
};
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const panes = [{
      title: 'CDN 域名配置',
      key: 'cdnConf'
    }, {
      title: '添加',
      key: 'addCdn'
    }];
    const active = ref('cdnConf');
    const cdnUrl = ref('');
    const handleBack = () => {
      console.log('object');
    };
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_i_ep_DeleteFilled = __unplugin_components_1;
      const _component_el_icon = __unplugin_components_2;
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      const _component_el_input = __unplugin_components_3;
      const _component_u_card = _resolveComponent("u-card");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_u_card, {
        onBack: handleBack,
        modelValue: _unref(active),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(active) ? active.value = $event : null),
        panes: panes
      }, {
        extra: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = $event => active.value = 'addCdn')
        }, {
          default: _withCtx(() => [_createTextVNode("添加")]),
          _: 1
        }, 512), [[_vShow, _unref(active) === 'cdnConf']])]),
        default: _withCtx(() => [_createVNode(_component_u_card_pane, {
          name: "cdnConf"
        }, {
          default: _withCtx(() => [_hoisted_2, _hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_i_ep_DeleteFilled)]),
            _: 1
          })])]),
          _: 1
        }), _createVNode(_component_u_card_pane, {
          name: "addCdn"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(cdnUrl),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(cdnUrl) ? cdnUrl.value = $event : null),
            placeholder: "请输入..."
          }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
            class: "marginT20",
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("确认")]),
            _: 1
          })])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});